var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350 700C543.3 700 700 543.3 700 350C700 156.7 543.3 0 350 0C156.7 0 0 156.7 0 350C0 543.3 156.7 700 350 700Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.044 380.259V380.216C389.637 380.391 377.234 381.134 349.562 381.134C327.469 381.134 311.916 380.478 306.447 380.216V380.281C221.397 376.541 157.916 361.731 157.916 344.012C157.916 326.316 221.397 311.506 306.447 307.7V365.537C312.003 365.931 327.928 366.872 349.934 366.872C376.337 366.872 389.572 365.778 392.044 365.559V307.744C476.919 311.528 540.247 326.337 540.247 344.012C540.247 361.731 476.919 376.497 392.044 380.259ZM392.044 301.728V249.972H510.475V171.047H188.016V249.972H306.447V301.706C210.197 306.125 137.812 325.2 137.812 348.037C137.812 370.875 210.197 389.928 306.447 394.369V560.225H392.044V394.325C488.141 389.906 560.35 370.853 560.35 348.037C560.35 325.222 488.141 306.169 392.044 301.728Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.9d24b8eb80e07f91fda52e28c6ab4c8b.svg";
export { ForwardRef as ReactComponent };